import { FETCH_EXPERIMENTS_SUCCESS } from './experiments-actions';
export function experimentsReducer(state = {}, action) {
    switch (action.type) {
        case FETCH_EXPERIMENTS_SUCCESS:
            return action.payload;
        default:
            return state;
    }
}
//# sourceMappingURL=experiments-reducer.js.map